import classes from './OrDivider.module.scss';

export default function OrDivider({ isSignup, isTouched, t, language }) {
  const dividerClass = () => {
    if (isTouched) {
      return isSignup ? classes.dividerDown : classes.dividerUp;
    }
    return isSignup ? classes.signupState : classes.loginState;
  };

  return (
    <span
      className={`${classes.divider} ${
        classes['divider-' + language]
      }  ${dividerClass()}`}
    >
      {t('or')}
    </span>
  );
}
